export default "__VITE_ASSET__BJ6YiX1C__"